import React, { useState } from 'react';
import { AllianceQuoteRequest, QuoteRequest } from '../../types/quote';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from '../LoadingSpinner';
import QuoteRequestRespondModal from './QuoteRequestRespondModal';
import ProfileMessageCard from '../common/ProfileMessageCard';

interface QuoteRequestListProps {
  quoteRequests: (QuoteRequest | AllianceQuoteRequest)[];
  loading?: boolean;
  showUnreadIndicator?: boolean;
  variant?: 'default' | 'simple';
}

const QuoteRequestList: React.FC<QuoteRequestListProps> = ({
  quoteRequests,
  loading,
  variant,
  showUnreadIndicator = true,
}) => {
  const { t } = useTranslation('prospects');

  const [selectedQuoteRequest, setSelectedQuoteRequest] = useState<
    QuoteRequest | AllianceQuoteRequest | null
  >(null);

  return (
    <div className="flex flex-col gap-4">
      {quoteRequests.length === 0 && !loading && (
        <div className="text-sm text-gray-500 mb-4">{t('noQuoteRequests')}</div>
      )}
      {quoteRequests.map(quoteRequest => {
        const isAllianceRequest = 'parent_quote_owner' in quoteRequest;
        const sourceProfile = isAllianceRequest
          ? quoteRequest.parent_quote_owner
          : quoteRequest.job.client;
        const sourceProfileName =
          'company_name' in sourceProfile
            ? sourceProfile.company_name || sourceProfile.first_name
            : `${sourceProfile.first_name} ${sourceProfile.last_name}`;
        const message = isAllianceRequest
          ? t('quoteRequestList.allianceQuoteRequestMessage')
          : t('quoteRequestList.quoteRequestMessage');
        return (
          <ProfileMessageCard
            key={quoteRequest.id}
            profile={{
              id: sourceProfile.id,
              firstName: sourceProfile.first_name,
              avatarUrl: sourceProfile.avatar_url,
            }}
            title={sourceProfileName}
            message={message}
            date={quoteRequest.created_at}
            showUnreadIndicator={showUnreadIndicator}
            variant={variant}
            actionButton={{
              onClick: () => {
                setSelectedQuoteRequest(quoteRequest);
              },
              label: t('showRequest', { ns: 'prospects' }),
            }}
          />
        );
      })}
      {loading && (
        <div className="flex justify-center items-center h-10">
          <LoadingSpinner />
        </div>
      )}
      {selectedQuoteRequest && (
        <QuoteRequestRespondModal
          quoteRequest={selectedQuoteRequest}
          onClose={() => setSelectedQuoteRequest(null)}
        />
      )}
    </div>
  );
};

export default QuoteRequestList;
